import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import ServicesImplementation from './pages/services-implementation';
import AICoreBlueprint from './pages/ai-core-blueprint';
import GetStarted from './pages/get-started';
import AboutAICleanCore from './pages/about-ai-clean-core';
import CaseStudiesProof from './pages/case-studies-proof';
import ResourcesHub from './pages/resources-hub';
import Homepage from './pages/homepage';
import OpenSourceAdvantage from './pages/open-source-advantage';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<AboutAICleanCore />} />
        <Route path="/services-implementation" element={<ServicesImplementation />} />
        <Route path="/ai-core-blueprint" element={<AICoreBlueprint />} />
        <Route path="/get-started" element={<GetStarted />} />
        <Route path="/about-ai-clean-core" element={<AboutAICleanCore />} />
        <Route path="/case-studies-proof" element={<CaseStudiesProof />} />
        <Route path="/resources-hub" element={<ResourcesHub />} />
        <Route path="/homepage" element={<Homepage />} />
        <Route path="/open-source-advantage" element={<OpenSourceAdvantage />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
